import { props } from '@ngrx/store';
import { createActionGroup, emptyProps } from '@ngrx/store';

import { Lesson } from '../models';

export const lessonActions = createActionGroup({
    source: 'Content Lessons',
    events: {
        'Get Lesson': props<{ id: string }>(),
        'Get Lesson Success': props<{ lesson: Lesson }>(),
        'Get Lesson Error': props<{ id: string }>(),

        Clear: emptyProps(),
    },
});
